import { render, staticRenderFns } from "./publicFooter.vue?vue&type=template&id=ea715d7c&scoped=true&"
import script from "./publicFooter.vue?vue&type=script&lang=js&"
export * from "./publicFooter.vue?vue&type=script&lang=js&"
import style0 from "./publicFooter.vue?vue&type=style&index=0&id=ea715d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea715d7c",
  null
  
)

export default component.exports